import { Variants } from 'framer-motion';

/** Callout animations */

/** Callout Wrapper (with gradient/grpahic background) animation */
export const calloutWrapperVariants: Variants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      duration: 0.9,
    },
  },
};

/** Individual callout animation */
export const calloutVariants: Variants = {
  hidden: {
    opacity: 0,
    x: -40,
    // Must match `visible` so Framer does not tween transform-origin from
    // computed pixel values (e.g. "175px 125px") to the keyword "left center".
    transformOrigin: 'left center',
  },
  // Pass in interval via the framer "custom" prop
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transformOrigin: 'left center',
    transition: {
      delay: i * 0.3,
      duration: 1,
      ease: 'easeOut',
    },
  }),
};

/** Inner callout text/img content animation */
export const innerCalloutVariants: Variants = {
  hidden: {
    opacity: 0,
    x: -8,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      delay: 0.85,
      duration: 0.45,
      ease: 'easeOut',
    },
  },
};

/** -----------------------------------------------------------------
 * GSAP Variables
 *  --------------------------------------------------------------- */
export const DURATION = 0.65;
export const EASE = 'sine.out';
export const DELAY = 3.35;
